export default "__VITE_ASSET__CJX9XzKL__"